import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useScrollAnimation, useStaggerAnimation } from "../hooks/useScrollAnimation";
import "./DetailPage.css";

function LunicaAIDetail() {
  const heroRef = useScrollAnimation();
  const featuresRef = useStaggerAnimation(3);
  const stepsRef = useStaggerAnimation(3);
  const capabilitiesRef = useStaggerAnimation(4);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="detail-page" style={{ background: 'linear-gradient(180deg, #000000 0%, #1a051a 50%, #3a0a3a 100%)' }}>
      <nav className="navbar">
        <div className="navbar-logo">
          <img src="/images/lunica_logo.png" alt="Lunica AI Logo" />
          <span>Lunica AI</span>
        </div>
        <div className="navbar-links">
          <Link to="/">Home</Link>
          <Link to="/lunicaai/privacy">Privacy Policy</Link>
          <Link to="/lunicaai/terms">Terms of Use</Link>
        </div>
      </nav>

      <div className="container">
        <div className="detail-hero">
          <div className="detail-hero-left animate-on-scroll" ref={heroRef}>
            <h1>Experience the future<br />of AI-powered creativity</h1>
            <p>
              Lunica AI is your <strong>intelligent creative companion</strong>, designed to enhance your workflow
              with cutting-edge artificial intelligence. Transform your ideas into reality with advanced AI models
              and intuitive tools that make complex tasks simple and accessible.
            </p>
            <div className="download-buttons">
              {/* <a href="https://play.google.com" className="download-btn" target="_blank" rel="noopener noreferrer">
                <img src="/images/download_android.png" alt="Google Play" />
              </a> */}
              <a href="https://apps.apple.com" className="download-btn" target="_blank" rel="noopener noreferrer">
                <img src="/images/download_ios.png" alt="App Store" />
              </a>
            </div>
          </div>
          <div className="detail-hero-right">
            <div className="phone-mockup phone-mockup-left">
              <img src="/images/lunicaai_screenshot1.png" alt="Lunica AI Screenshot 1" />
            </div>
            <div className="phone-mockup phone-mockup-right">
              <img src="/images/lunicaai_screenshot2.png" alt="Lunica AI Screenshot 2" />
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="detail-features">
          <h2>Why Choose Lunica AI?</h2>
          <div className="features-grid" ref={featuresRef}>
            <div className="feature-card stagger-item">
              <h3>Advanced AI Technology</h3>
              <p>Powered by state-of-the-art AI models that deliver exceptional results for all your creative needs.</p>
            </div>
            <div className="feature-card stagger-item">
              <h3>Intuitive Interface</h3>
              <p>Beautiful, user-friendly design that makes complex AI tools accessible to everyone.</p>
            </div>
            <div className="feature-card stagger-item">
              <h3>Fast & Efficient</h3>
              <p>Get results in seconds with optimized processing and seamless performance.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="detail-how-it-works">
          <h2>How It Works</h2>
          <div className="steps-grid" ref={stepsRef}>
            <div className="step stagger-item">
              <div className="step-number">1</div>
              <h3>Get Started</h3>
              <p>Download the app and create your account</p>
            </div>
            <div className="step stagger-item">
              <div className="step-number">2</div>
              <h3>Choose Your Tool</h3>
              <p>Select from our range of AI-powered features</p>
            </div>
            <div className="step stagger-item">
              <div className="step-number">3</div>
              <h3>Create & Share</h3>
              <p>Generate amazing content and share your creations</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="detail-extra-section">
          <h2>AI Capabilities</h2>
          <div className="features-grid" ref={capabilitiesRef}>
            <div className="feature-card stagger-item">
              <h3>Smart Processing</h3>
              <p>Intelligent algorithms that understand context and deliver precise results</p>
            </div>
            <div className="feature-card stagger-item">
              <h3>Real-time Generation</h3>
              <p>Create content instantly with real-time AI processing capabilities</p>
            </div>
            <div className="feature-card stagger-item">
              <h3>High Quality Output</h3>
              <p>Professional-grade results suitable for any use case or platform</p>
            </div>
            <div className="feature-card stagger-item">
              <h3>Customizable Options</h3>
              <p>Fine-tune settings to match your specific needs and preferences</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LunicaAIDetail;
